export default function encodeIcon(icon : string) {
  return `data:image/svg+xml,${encodeURIComponent(icon)}`;
}
